// import { randomHexColorWithArray } from 'random-hex-color-generator';
// import React, { useEffect, useState } from 'react'
// import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';

function GenderRatioGraph({ genderRatioGraphData }) {
    // const [colors, setColors] = useState([]);
    // const [sortedPieData, setSortedPieData] = useState([]);

    // useEffect(() => {
    //     const colorsArray = randomHexColorWithArray(genderRatioGraphData.length);
    //     setColors(colorsArray);

    //     setSortedPieData(genderRatioGraphData.sort((a,b) => b.value - a.value));
    // }, [genderRatioGraphData]);

    // const dimensions = {
    //     innerRadius: 40,
    //     outerRadius: 70,
    //     width: 55,
    // }

    // const [graphDimensions, setGraphDimensions] = useState(dimensions);
    // const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // useEffect(() => {
    //     const handleResize = () => {
    //         setWindowWidth(window.innerWidth);
    //     };
    
    //     window.addEventListener('resize', handleResize);
    
    //     return () => {
    //         window.removeEventListener('resize', handleResize);
    //     };
    // }, []);
    
    // useEffect(() => {
    //     if (windowWidth < 1280) {
    //         if(windowWidth < 1081) {
    //             setGraphDimensions({
    //                 innerRadius: 35,
    //                 outerRadius: 60,
    //                 width: 60
    //             });
    //         }
    //         else {
    //             setGraphDimensions({
    //                 outerRadius: 65,
    //             });
    //         }
    //     }
    // }, [windowWidth]);

    return (
        <div className="border-[1px] rounded-lg border-[#EAEAEA] col-span-1 min-h-[20vh] p-5 max-[1080px]:px-[14px] flex flex-col gap-4">
            <div className="flex items-center justify-between">
                <h1 className="font-urbanist-regular font-semibold text-[16px] leading-6">Gender</h1>
            </div>

            <div className="m-auto">
                <h1 className='font-urbanist-regular font-normal italic text-base text-[#666666]'>Available soon</h1>
            </div>

            <div className="flex items-center w-full h-full gap-1">
                {/* <ResponsiveContainer className='relative' width={`${graphDimensions.width}%`} height="100%">
                    <PieChart>
                        <Pie
                            data={genderRatioGraphData}
                            innerRadius={graphDimensions.innerRadius}
                            outerRadius={graphDimensions.outerRadius} 
                            fill="#8884d8"
                            paddingAngle={0}
                            dataKey="percentage" 
                        >
                            {genderRatioGraphData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                            ))}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer> */}
            
                {/* <div className="flex flex-col gap-8 w-[45%] max-[1280px]:w-[40%]">
                    {sortedPieData.map((item, index) => {
                        return (
                            <div className='flex w-full gap-2 items-center justify-between' key={index}>
                                <div className="flex gap-2 items-center">
                                    <div className='rounded-[4px] h-3 w-3' style={{ backgroundColor: colors[index] }}></div>

                                    <h2 className='text-[12px] leading-5 font-urbanist-regular font-semibold text-[#666666]'>{item.name}</h2>
                                </div>

                                <h2 className="text-[12px] leading-5 font-urbanist-regular font-semibold">{item.percentage.toFixed(0)}%</h2>
                            </div>
                        )
                    })}
                </div> */}
            </div>
        </div>
    );
}

export default GenderRatioGraph;
